import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "서비스 약관",
  "description": "당사의 서비스 약관 및 귀하와의 관계에 대해 확인하세요."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "아래에 명시된 이용 약관(\"약관\")은 본 사이트의 사용을 규정합니다. 본 약관은 귀하와 VERCEL INC.(\"Vercel\", \"당사\" 또는 \"저희\") 간의 법적 계약이며 TURBOREPO.ORG 웹사이트(\"사이트\")에 대한 귀하의 액세스 및 사용을 규정합니다. 본 약관 중 어느 하나라도 동의하지 않는 경우, 본 사이트 또는 본 사이트에 포함된 정보에 액세스하거나 사용하지 마십시오. 본 사이트의 사용은 아래에 명시된 각 약관을 준수하기로 동의한 것으로 간주됩니다. VERCEL은 언제든지 본 사이트에서 제공되는 콘텐츠를 변경할 수 있습니다. VERCEL은 언제든지 본 약관을 변경할 수 있습니다. VERCEL이 변경 사항을 적용하는 경우, VERCEL은 본 사이트에 업데이트된 이용 약관을 게시하며 등록된 사용자에게 변경 사항에 대한 이메일 통지를 보낼 수 있습니다. 변경 사항이 귀하에게 받아들일 수 없는 경우, 본 사이트의 사용을 중단해야 합니다. 본 사이트의 사용을 중단하지 않는 경우, 변경 사항을 수락한 것으로 간주됩니다."
  }, {
    "heading": "",
    "content": "TURBOREPO 소프트웨어는 오픈소스 라이선스에 따라 별도로 제공되며, 본 사이트에서 TURBOREPO 소프트웨어 및 관련 라이선스에 대한 링크를 찾을 수 있습니다."
  }, {
    "heading": "일반-사용-제한",
    "content": "Vercel은 본 사이트를 통해 다양한 콘텐츠를 제공합니다. 본 사이트에서 제공되는 특정 정보, 문서, 설명서, 제품 및 서비스(콘텐츠, 로고, 그래픽 및 이미지 포함, 총칭하여 \"자료\")는 Vercel이 귀하에게 제공하며 Vercel 또는 Vercel의 라이선서의 저작권 및/또는 상표권으로 보호되는 작업물입니다."
  }, {
    "heading": "일반-사용-제한",
    "content": "Vercel은 귀하에게 오직 개인용 또는 내부 비즈니스 용도로만 자료를 사용하고 표시하며 한 부를 복사할 수 있는 제한적이고 개인적이며 비독점적이고 양도 불가능한 라이선스를 부여합니다. 위의 전 문장에 명시된 라이선스를 제외하고, 귀하는 어떠한 방식으로든 자료를 수정, 편집, 복사, 복제, 2차 저작물 생성, 역설계, 변경, 개선 또는 활용할 권리가 없음을 인정하고 동의합니다. 이 제한적 라이선스는 귀하가 본 약관 중 하나라도 위반하는 경우 귀하에게 통지 없이 자동으로 종료됩니다. 본 약관에 명시된 경우를 제외하고, 귀하는 본 사이트 또는 자료에 대한 권리, 소유권 또는 이익이 없음을 인정합니다."
  }, {
    "heading": "개인정보-보호정책",
    "content": "본 사이트의 사용은 https://vercel.com/legal/privacy-policy에서 확인할 수 있는 Vercel의 개인정보 보호정책(\"개인정보 보호정책\")의 적용을 받습니다."
  }, {
    "heading": "제3자-콘텐츠",
    "content": "사이트의 특정 정보 및 기타 콘텐츠는 Vercel에 대한 제3자 라이선서 및 공급자의 자료일 수 있습니다(\"제3자 콘텐츠\"). 제3자 콘텐츠는 각각의 경우에 제작자/라이선서의 저작권 및/또는 상표권으로 보호되는 작업물입니다. 귀하는 오직 개인용 또는 내부 비즈니스 용도로만 컴퓨터에 제3자 콘텐츠를 표시하는 데 동의합니다. 귀하는 제3자 콘텐츠의 소유자로부터 허가를 받지 않는 한 어떠한 방식으로든 제3자 콘텐츠를 다운로드, 캐시, 복제, 수정, 표시(본 단락에 명시된 경우 제외), 편집, 변경 또는 개선할 권리가 없음을 인정하고 동의합니다. Vercel은 제3자 콘텐츠와 관련하여 상품성, 특정 목적에의 적합성 및 비침해에 대한 묵시적 보증을 포함하되 이에 국한되지 않는 모든 명시적, 묵시적 및 법적 보증 및 조건을 부인합니다."
  }, {
    "heading": "다른-vercel-사이트-및-제3자-사이트에-대한-링크",
    "content": "본 사이트는 Vercel 및 그 서비스에 관한 기타 정보를 찾을 수 있는 다른 Vercel 사이트에 연결될 수 있습니다.\n본 사이트는 또한 Vercel 사이트가 아닌 다른 사이트에 연결됩니다. Vercel은 편의를 위해서만 이러한 링크를 귀하에게 제공하며, Vercel은 해당 사이트에 표시된 콘텐츠 또는 링크를 포함하되 이에 국한되지 않는 연결된 사이트에 대해 책임을 지지 않습니다."
  }, {
    "heading": "무단-활동",
    "content": "본 사이트에 포함된 자료 또는 제3자 콘텐츠를 무단으로 사용하는 것은 특정 법률 및 규정을 위반할 수 있습니다. 귀하는 본 사이트의 사용이 적용 가능한 법률 또는 규정, 또는 제3자의 저작권, 상표권 또는 기타 권리를 위반한다는 제3자의 청구 또는 요구와 관련하여, 그로부터 발생하거나, 이를 회피할 목적으로 Vercel 또는 기타 피면책 당사자가 겪는 모든 비용, 손해, 책임 및 비용(변호사 비용 및 변호 비용 포함)으로부터 Vercel 및 그 임원, 이사, 직원, 계열사, 대리인, 라이선서 및 비즈니스 파트너를 면책하고 손해로부터 보호하는 데 동의합니다."
  }, {
    "heading": "소유권",
    "content": "Vercel 및 Turborepo는 Vercel의 상표입니다. 본 사이트의 기타 상표, 이름 및 로고는 각 소유자의 재산입니다."
  }, {
    "heading": "소유권",
    "content": "본 약관에 달리 명시되지 않는 한, 문서, 서비스, 사이트 디자인, 텍스트, 그래픽, 로고, 이미지 및 아이콘과 이들의 배열을 포함하여 본 사이트에 나타나는 모든 정보 및 화면은 Vercel Inc.의 단독 재산입니다. Copyright © 2021-2022 Vercel Inc. 본 약관에 명시적으로 부여되지 않은 모든 권리는 유보됩니다. 적용 가능한 법률에 의해 달리 요구되거나 제한되는 경우를 제외하고, 저작권 소유자 또는 라이선스의 명시적 서면 동의 없이 저작권으로 보호되는 자료의 복제, 배포, 수정, 재전송 또는 출판은 엄격히 금지됩니다."
  }, {
    "heading": "보증-부인",
    "content": "본 사이트의 사용은 귀하의 책임입니다. 자료 및 제3자 콘텐츠는 Vercel에 의해 전체적으로 또는 부분적으로 검증되거나 인증되지 않았으며, 부정확한 내용 또는 오타 또는 기타 오류를 포함할 수 있습니다. Vercel은 본 사이트에 포함된 자료 또는 제3자 콘텐츠의 정확성 또는 적시성을 보증하지 않습니다. Vercel은 Vercel 또는 당사의 라이선서가 제공하는지 여부와 관계없이 자료 및/또는 제3자 콘텐츠의 오류 또는 누락에 대해 책임을 지지 않습니다."
  }, {
    "heading": "보증-부인",
    "content": "VERCEL은 자체 및 그 라이선서를 위하여, 본 사이트, 자료 또는 제3자 콘텐츠와 관련하여, 본 사이트에 포함되거나 제시된 정보 또는 자료의 품질, 적합성, 진실성, 정확성 또는 완전성 및/또는 자료 및 제3자 콘텐츠를 포함하되 이에 국한되지 않는 본 사이트의 사용으로부터 얻은 결과와 관련하여 명시적, 묵시적 또는 법적 진술, 보증 또는 보장을 하지 않습니다. 적용 가능한 법률에 의해 허용되는 최대 범위까지, 본 사이트, 서비스, 자료, 제3자 콘텐츠 및 본 사이트에 포함되거나 제시된 정보 또는 자료는 상품성, 특정 목적에의 적합성 또는 제3자 권리의 비침해에 대한 묵시적 보증 없이 \"있는 그대로\", \"사용 가능한 그대로\" 및 \"현재 상태 그대로\"를 기준으로 귀하에게 제공됩니다. VERCEL은 귀하의 컴퓨터에 설치될 수 있는 바이러스, 스파이웨어 또는 멀웨어에 대한 보증을 제공하지 않습니다. VERCEL은 귀하를 전문가 또는 고객으로 수락하거나 거부할지 여부에 대한 단독 재량권을 가집니다."
  }, {
    "heading": "책임의-제한",
    "content": "VERCEL은 본 사이트로 또는 본 사이트로부터 자료 또는 제3자 콘텐츠를 표시, 복사 또는 다운로드하여 발생하는 손해에 대해 귀하에게 책임을 지지 않습니다. VERCEL이 그러한 손해의 가능성을 알고 있는 경우에도, 어떠한 경우에도 VERCEL은 간접적, 특별한, 예시적, 징벌적, 특수한, 부수적 또는 결과적 손해(데이터, 수익, 이익, 사용 또는 기타 경제적 이익의 손실 포함)에 대해 귀하에게 책임을 지지 않으며, 총 손해가 100달러를 초과하는 경우에도 마찬가지입니다."
  }, {
    "heading": "현지-법률-수출-통제",
    "content": "Vercel은 미국 본사에서 본 사이트를 통제하고 운영하며 자료 및/또는 제3자 콘텐츠는 다른 지역에서 사용하기에 적절하지 않거나 사용할 수 없을 수 있습니다. 미국 외부에서 본 사이트를 사용하는 경우, 귀하는 적용 가능한 현지 법률을 준수할 책임이 있습니다."
  }, {
    "heading": "일반-조항",
    "content": "귀하가 본 약관을 위반하는 경우, Vercel은 통지 없이 본 사이트에 대한 귀하의 액세스를 종료 및/또는 일시 중단할 수 있습니다. 소유권, 보증 부인, 귀하가 한 진술, 면책, 책임의 제한 및 일반 조항은 본 약관의 종료 후에도 존속합니다."
  }, {
    "heading": "일반-조항",
    "content": "Vercel은 사이트에 통지를 게시하여 30일 전에 통지함으로써 때때로 본 약관을 변경할 수 있습니다. 귀하는 언제든지 본 사이트에서 본 약관의 최신 버전을 검토할 수 있습니다. 개정된 약관은 Vercel이 그러한 변경 사항에 대한 통지를 게시하거나 귀하에게 보낸 후 30일 후에 발효되며, 그 날짜 이후에 사이트를 사용하는 경우 귀하의 사용은 개정된 약관의 수락으로 간주됩니다. 본 약관에 대한 변경 사항이 귀하에게 받아들일 수 없는 경우, 귀하의 유일한 구제책은 사이트 사용을 중단하는 것입니다. 본 약관의 조항이 시행 불가능하거나 무효인 것으로 판명되는 경우, 본 약관이 달리 완전한 효력을 유지하고 시행 가능하도록 해당 조항은 필요한 최소한으로 제한되거나 제거됩니다. 귀하는 Vercel의 사전 서면 동의 없이 양도, 이전 또는 재라이선스할 수 없지만, Vercel은 제한 없이 본 약관을 전체적으로 또는 부분적으로 양도하거나 이전할 수 있습니다. 전술한 내용에 위배되는 당사자의 본 약관의 양도 또는 이전 시도는 무효입니다. 본 약관은 당사자 간의 상호 이해에 대한 완전하고 배타적인 진술이며 본 약관의 주제와 관련된 모든 이전의 서면 및 구두 계약, 통신 및 기타 이해를 대체하고 취소하며, 본 약관에 달리 규정된 경우를 제외하고 모든 수정 사항은 양 당사자가 서명한 서면으로 이루어져야 합니다. Vercel이 본 약관의 권리 또는 조항을 행사하거나 시행하지 않는 것은 해당 권리의 포기가 아닙니다. 본 약관의 결과로 대리, 파트너십, 합작 투자 또는 고용이 생성되지 않으며 어느 당사자도 어떠한 면에서든 상대방을 구속할 권한이 없습니다. 본 약관에 따른 권리를 시행하기 위한 소송 또는 절차에서 승소한 당사자는 비용 및 변호사 비용을 회수할 자격이 있습니다. 위에 명시된 경우를 제외하고, 본 약관에 따른 모든 통지는 서면으로 이루어지며 직접 전달된 경우 수령 시, 이메일로 전송된 경우 전자적으로 확인된 때, 공인 익일 배송 서비스로 익일 배송을 위해 발송된 경우 발송 다음 날, 등기 우편으로 발송된 경우 수령 시 정식으로 제공된 것으로 간주됩니다."
  }, {
    "heading": "일반-조항",
    "content": "Vercel의 이행 지연 또는 실패는 그러한 지연 또는 이행 실패가 Vercel의 합리적인 통제를 벗어난 사건(신의 행위 또는 공공의 적, 테러 행위, 팬데믹, 전염병, 노동 파업, 시설의 수용 또는 몰수, 예상치 못한 정식으로 공포된 정부 명령의 준수, 전쟁 행위, 반란 또는 사보타주 또는 그로 인한 손해, 화재, 홍수, 폭발 또는 폭동을 포함하되 이에 국한되지 않음)으로 인한 것이고, 그러한 범위 내에서, 그리고 그러한 기간 동안, 본 약관의 불이행을 구성하거나 손해 배상 청구를 발생시키지 않습니다."
  }, {
    "heading": "준거법-분쟁-중재",
    "content": "법률. 본 약관은 캘리포니아주 법률의 저촉 규정에 관계없이 캘리포니아주 법률의 적용을 받으며, 당사자들은 샌프란시스코 카운티의 주 및 연방 법원의 전속 관할권에 동의합니다."
  }, {
    "heading": "준거법-분쟁-중재",
    "content": "구속력 있는 계약. 귀하는 본 약관이 전자적이며 귀하와 Vercel이 물리적으로 서명하지 않았더라도 귀하와 Vercel 간의 계약이며, 사이트의 사용을 규정함을 인정합니다."
  }, {
    "heading": "준거법-분쟁-중재",
    "content": "중재. 본 조항의 특정 부분은 연방 중재법(\"FAA\")에 따른 \"중재에 대한 서면 합의\"로 간주됩니다. 귀하와 Vercel은 본 조항이 연방 중재법의 \"서면\" 요건을 충족함을 명시적으로 동의하고 의도합니다. 본 조항은 상호 합의에 의해서만 수정될 수 있습니다. 본 조항의 목적상, \"청구\"는 (i) 관련된 모든 콘텐츠, 자료 및 소프트웨어를 포함한 사이트 및/또는 (ii) 귀하의 사이트 사용으로부터 발생하거나 이와 관련된 모든 청구, 상해, 요구, 책임, 분쟁, 소송 원인(법적, 계약적, 과실 또는 기타 불법 행위 이론 포함), 절차, 의무, 부채, 유치권, 벌금, 요금, 위약금, 계약, 약속, 비용, 지출(소송 전, 재판 전, 재판 중, 항소 중 또는 기타 시점에 발생했는지 여부와 관계없이 변호사 비용 포함), 모든 종류의 손해(결과적, 보상적 또는 징벌적 손해 포함) 또는 손실(알려진, 알려지지 않은, 주장된, 주장되지 않은, 확정된, 조건부 또는 우발적인 것인지 여부)을 총칭하여 의미하며 이에 국한되지 않습니다."
  }, {
    "heading": "준거법-분쟁-중재",
    "content": "비공식 분쟁 해결. 본 약관에 규정된 경우를 제외하고 사이트 또는 본 약관으로부터 발생하거나 이와 관련된 청구가 발생하는 경우, 귀하와 Vercel은 청구에 대한 합리적인 설명과 제안된 해결책을 제공하는 통지를 상대방에게 보내는 데 동의합니다. 귀하에 대한 Vercel의 통지는 귀하가 Vercel에 제공한 가장 최근의 연락처 정보를 기반으로 전송됩니다. 그러한 정보가 존재하지 않거나 그러한 정보가 최신이 아닌 경우, Vercel은 본 조항에 따른 의무가 없습니다. 상대방으로부터 통지를 받은 날로부터 60일 동안, 귀하와 Vercel은 청구를 해결하기 위해 대화에 참여하지만, 귀하와 Vercel 각각의 단독 재량에 따라 편안하지 않은 조건으로 청구를 해결하도록 요구하는 것은 없습니다."
  }, {
    "heading": "준거법-분쟁-중재",
    "content": "적용 법률. 귀하와 Vercel이 통지를 받은 날로부터 60일 이내에 청구를 해결할 수 없는 경우, 귀하는 그러한 청구 및 본 약관의 해석, 적용 가능성, 시행 가능성 또는 형성과 관련하여 발생하거나 관련된 모든 기타 분쟁(본 약관의 전부 또는 일부가 무효이거나 취소 가능하다는 청구 또는 청구가 귀하의 사이트 사용과 관련된 중재의 대상인지 여부를 포함하되 이에 국한되지 않음)이 법원이 아닌 구속력 있는 중재로 해결될 것에 동의합니다. 주법이 아닌 FAA가 아래의 집단 소송 포기를 포함하여 그러한 분쟁의 중재 가능성을 규정합니다. 그러나 귀하와 Vercel은 캘리포니아주 법률 또는 미국 연방법이 법률 선택 원칙에 관계없이 계약, 법령, 관습법 또는 기타 법적 이론에서 발생하거나 명시된 본 약관 및 사이트와 관련하여 귀하와 Vercel 간에 발생하는 모든 청구 또는 분쟁에 적절하게 적용되고 규정됨에 동의합니다. 중재에는 판사나 배심원이 없으며, 중재 판정에 대한 법원 검토는 제한됩니다. 그러나 중재인은 법원이 하는 것처럼 본 약관의 조건을 따라야 합니다. 구속력 있는 중재 및 집단 소송 포기에 대한 조항을 포함한 본 조항은 귀하의 계정 또는 서비스의 종료 후에도 존속합니다."
  }, {
    "heading": "준거법-분쟁-중재",
    "content": "중재 요청. 중재 절차를 시작하려면 중재를 요청하고 귀하의 청구를 설명하는 서신을 340 S Lemon Ave #4133, Walnut CA, 91789의 Vercel에 보내야 합니다. 중재는 중재가 개시될 때 시행 중인 JAMS 간소화 중재 절차 규칙에 따라 JAMS에 의해 수행되며, 집단 소송을 규정하거나 허용하는 규칙 또는 절차는 제외됩니다. 모든 제출, 관리 및 중재인 수수료의 지불은 JAMS의 규칙에 따라 규정됩니다. 중재는 캘리포니아주 샌프란시스코 또는 상호 합의된 다른 장소(및 그러한 절차에 따라)에서 진행됩니다. 귀하는 다음과 같이 JAMS 절차, 규칙 및 수수료 정보를 얻을 수 있습니다: JAMS: 800.352.5267 및 https://www.jamsadr.com."
  }, {
    "heading": "준거법-분쟁-중재",
    "content": "수수료. 귀하와 Vercel은 적용 가능한 중재 규칙에 따라 관리 및 중재인의 수수료 및 기타 비용을 지불합니다. 그러나 적용 가능한 중재 규칙 또는 법률이 본 조항이 시행 가능하도록 Vercel이 그러한 수수료 및 비용의 더 큰 부분 또는 전부를 지불하도록 요구하는 경우, Vercel은 수수료 및 비용을 지불하고 중재를 진행하기로 선택할 권리가 있습니다. 중재 규칙은 Vercel이 변호사 비용을 회수하는 것을 허용할 수 있습니다. Vercel은 중재인이 청구가 경솔하다고 판단하지 않는 한 중재에서 변호사 비용 및 비용을 회수하려고 하지 않습니다."
  }, {
    "heading": "준거법-분쟁-중재",
    "content": "집단 소송 포기. 귀하와 VERCEL은 각각 분쟁 해결 절차가 집단, 통합 또는 대표 소송이 아닌 개인 기반으로만 수행될 것에 동의합니다. 귀하와 Vercel은 각각 그러한 절차가 캘리포니아 민사소송법 제638조에 따른 사법 참조 방식으로만 진행되어야 함에 동의합니다."
  }, {
    "heading": "준거법-분쟁-중재",
    "content": "예외. 중재를 통해 모든 분쟁을 해결한다는 합의에도 불구하고, 귀하 또는 Vercel은 지적 재산권(특허, 저작권, 상표, 영업 비밀 및 도덕적 권리를 포함하되 개인정보 보호 권리는 포함하지 않음)의 침해 또는 기타 오용을 금지하기 위해 법원에 소송을 제기할 수 있습니다. 귀하 또는 Vercel은 또한 해당 법원의 관할권 범위 내의 청구에 대해 소액 청구 법원에서 구제를 요청할 수 있습니다. 위의 중재 조항이 귀하 또는 특정 청구에 적용되지 않는 것으로 판명되는 경우, 귀하의 중재 조항 옵트아웃 결정의 결과로든 중재인의 결정 또는 법원 명령의 결과로든, 귀하는 그러한 청구 또는 분쟁에 대한 재판지가 캘리포니아주 샌프란시스코 카운티에 위치한 주 또는 연방 법원에만 있다는 데 동의합니다. 귀하와 Vercel은 중재 조항이 적용되지 않는 것으로 판명되는 경우 본 약관의 해석, 적용 가능성, 시행 가능성 또는 형성 또는 귀하의 사이트 사용과 관련하여 발생하거나 관련된 모든 그러한 청구 또는 기타 분쟁을 소송하기 위해 캘리포니아주 샌프란시스코 카운티 내에 위치한 법원의 대인 관할권에 복종하는 데 동의합니다. 그러한 경우, Vercel이 본 약관에 따른 권리를 시행하기 위해 귀하를 상대로 한 소송에서 승소하는 경우, Vercel은 Vercel이 받을 자격이 있는 모든 기타 손해 배상 또는 판정 외에도 분쟁을 해결하거나 합의하는 데 발생한 비용, 지출 및 합리적인 변호사 비용(재판, 항소 중 또는 준비 중 또는 기타 시점에 발생했는지 여부)을 받을 자격이 있습니다."
  }, {
    "heading": "준거법-분쟁-중재",
    "content": "제한. 적용 가능한 법률에 의해 허용되는 최대 범위까지, 귀하 또는 VERCEL이 상대방에 대해 분쟁을 주장하고자 하는 경우, 귀하 또는 VERCEL은 분쟁이 발생한 후 1년 이내에(본 약관에 명시된 대로 서면 통지를 전달하여) 이를 시작해야 하며 그렇지 않으면 영구히 금지됩니다. \"시작\"은 해당되는 경우 다음을 의미합니다: (i) 본 약관에 명시된 대로 서면 통지를 전달, (ii) 본 약관에 명시된 대로 JAMS에 중재 신청, 또는 (iii) 주 또는 연방 법원에 소송 제기. 이 조항은 사이트와 관련된 손실(또는 잠재적 손실), Vercel의 지적 재산권 및/또는 Vercel의 사이트 제공과 관련하여 금지 명령 또는 기타 형평법상 구제를 구하기 위해 Vercel이 취한 법적 조치에는 적용되지 않습니다."
  }, {
    "heading": "준거법-분쟁-중재",
    "content": "옵트아웃. 귀하는 privacy@vercel.com으로 제목란에 \"COMPANY ARBITRATION AND CLASS ACTION WAIVER OPT-OUT\"을 기재하여 옵트아웃 결정에 대한 서면 통지를 보냄으로써 위에 명시된 중재 및 집단 소송 포기 조항에 구속되지 않도록 옵트아웃할 권리가 있습니다. 통지는 사이트의 첫 사용 후 30일 이내에 보내야 하며, 그렇지 않으면 귀하는 구속력 있는 중재를 규정하는 본 약관에 따라 분쟁을 중재하도록 구속됩니다. 귀하가 이러한 중재 조항을 옵트아웃하는 경우, Vercel도 이에 구속되지 않습니다."
  }, {
    "heading": "준거법-분쟁-중재",
    "content": "최종 업데이트 날짜: 2021년 12월 8일"
  }],
  "headings": [{
    "id": "일반-사용-제한",
    "content": "일반 사용 제한"
  }, {
    "id": "개인정보-보호정책",
    "content": "개인정보 보호정책"
  }, {
    "id": "제3자-콘텐츠",
    "content": "제3자 콘텐츠"
  }, {
    "id": "다른-vercel-사이트-및-제3자-사이트에-대한-링크",
    "content": "다른 Vercel 사이트 및 제3자 사이트에 대한 링크"
  }, {
    "id": "무단-활동",
    "content": "무단 활동"
  }, {
    "id": "소유권",
    "content": "소유권"
  }, {
    "id": "보증-부인",
    "content": "보증 부인"
  }, {
    "id": "책임의-제한",
    "content": "책임의 제한"
  }, {
    "id": "현지-법률-수출-통제",
    "content": "현지 법률; 수출 통제"
  }, {
    "id": "일반-조항",
    "content": "일반 조항"
  }, {
    "id": "준거법-분쟁-중재",
    "content": "준거법; 분쟁; 중재"
  }]
};
export const toc = [{
  depth: 2,
  url: "#일반-사용-제한",
  title: _jsx(_Fragment, {
    children: "일반 사용 제한"
  })
}, {
  depth: 2,
  url: "#개인정보-보호정책",
  title: _jsx(_Fragment, {
    children: "개인정보 보호정책"
  })
}, {
  depth: 2,
  url: "#제3자-콘텐츠",
  title: _jsx(_Fragment, {
    children: "제3자 콘텐츠"
  })
}, {
  depth: 2,
  url: "#다른-vercel-사이트-및-제3자-사이트에-대한-링크",
  title: _jsx(_Fragment, {
    children: "다른 Vercel 사이트 및 제3자 사이트에 대한 링크"
  })
}, {
  depth: 2,
  url: "#무단-활동",
  title: _jsx(_Fragment, {
    children: "무단 활동"
  })
}, {
  depth: 2,
  url: "#소유권",
  title: _jsx(_Fragment, {
    children: "소유권"
  })
}, {
  depth: 2,
  url: "#보증-부인",
  title: _jsx(_Fragment, {
    children: "보증 부인"
  })
}, {
  depth: 2,
  url: "#책임의-제한",
  title: _jsx(_Fragment, {
    children: "책임의 제한"
  })
}, {
  depth: 2,
  url: "#현지-법률-수출-통제",
  title: _jsx(_Fragment, {
    children: "현지 법률; 수출 통제"
  })
}, {
  depth: 2,
  url: "#일반-조항",
  title: _jsx(_Fragment, {
    children: "일반 조항"
  })
}, {
  depth: 2,
  url: "#준거법-분쟁-중재",
  title: _jsx(_Fragment, {
    children: "준거법; 분쟁; 중재"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    p: "p",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "아래에 명시된 이용 약관(\"약관\")은 본 사이트의 사용을 규정합니다. 본 약관은 귀하와 VERCEL INC.(\"Vercel\", \"당사\" 또는 \"저희\") 간의 법적 계약이며 TURBOREPO.ORG 웹사이트(\"사이트\")에 대한 귀하의 액세스 및 사용을 규정합니다. 본 약관 중 어느 하나라도 동의하지 않는 경우, 본 사이트 또는 본 사이트에 포함된 정보에 액세스하거나 사용하지 마십시오. 본 사이트의 사용은 아래에 명시된 각 약관을 준수하기로 동의한 것으로 간주됩니다. VERCEL은 언제든지 본 사이트에서 제공되는 콘텐츠를 변경할 수 있습니다. VERCEL은 언제든지 본 약관을 변경할 수 있습니다. VERCEL이 변경 사항을 적용하는 경우, VERCEL은 본 사이트에 업데이트된 이용 약관을 게시하며 등록된 사용자에게 변경 사항에 대한 이메일 통지를 보낼 수 있습니다. 변경 사항이 귀하에게 받아들일 수 없는 경우, 본 사이트의 사용을 중단해야 합니다. 본 사이트의 사용을 중단하지 않는 경우, 변경 사항을 수락한 것으로 간주됩니다."
    }), "\n", _jsx(_components.p, {
      children: "TURBOREPO 소프트웨어는 오픈소스 라이선스에 따라 별도로 제공되며, 본 사이트에서 TURBOREPO 소프트웨어 및 관련 라이선스에 대한 링크를 찾을 수 있습니다."
    }), "\n", _jsx(_components.h2, {
      id: "일반-사용-제한",
      children: "일반 사용 제한"
    }), "\n", _jsx(_components.p, {
      children: "Vercel은 본 사이트를 통해 다양한 콘텐츠를 제공합니다. 본 사이트에서 제공되는 특정 정보, 문서, 설명서, 제품 및 서비스(콘텐츠, 로고, 그래픽 및 이미지 포함, 총칭하여 \"자료\")는 Vercel이 귀하에게 제공하며 Vercel 또는 Vercel의 라이선서의 저작권 및/또는 상표권으로 보호되는 작업물입니다."
    }), "\n", _jsx(_components.p, {
      children: "Vercel은 귀하에게 오직 개인용 또는 내부 비즈니스 용도로만 자료를 사용하고 표시하며 한 부를 복사할 수 있는 제한적이고 개인적이며 비독점적이고 양도 불가능한 라이선스를 부여합니다. 위의 전 문장에 명시된 라이선스를 제외하고, 귀하는 어떠한 방식으로든 자료를 수정, 편집, 복사, 복제, 2차 저작물 생성, 역설계, 변경, 개선 또는 활용할 권리가 없음을 인정하고 동의합니다. 이 제한적 라이선스는 귀하가 본 약관 중 하나라도 위반하는 경우 귀하에게 통지 없이 자동으로 종료됩니다. 본 약관에 명시된 경우를 제외하고, 귀하는 본 사이트 또는 자료에 대한 권리, 소유권 또는 이익이 없음을 인정합니다."
    }), "\n", _jsx(_components.h2, {
      id: "개인정보-보호정책",
      children: "개인정보 보호정책"
    }), "\n", _jsxs(_components.p, {
      children: ["본 사이트의 사용은 ", _jsx(_components.a, {
        href: "https://vercel.com/legal/privacy-policy%EC%97%90%EC%84%9C",
        children: "https://vercel.com/legal/privacy-policy에서"
      }), " 확인할 수 있는 Vercel의 개인정보 보호정책(\"개인정보 보호정책\")의 적용을 받습니다."]
    }), "\n", _jsx(_components.h2, {
      id: "제3자-콘텐츠",
      children: "제3자 콘텐츠"
    }), "\n", _jsx(_components.p, {
      children: "사이트의 특정 정보 및 기타 콘텐츠는 Vercel에 대한 제3자 라이선서 및 공급자의 자료일 수 있습니다(\"제3자 콘텐츠\"). 제3자 콘텐츠는 각각의 경우에 제작자/라이선서의 저작권 및/또는 상표권으로 보호되는 작업물입니다. 귀하는 오직 개인용 또는 내부 비즈니스 용도로만 컴퓨터에 제3자 콘텐츠를 표시하는 데 동의합니다. 귀하는 제3자 콘텐츠의 소유자로부터 허가를 받지 않는 한 어떠한 방식으로든 제3자 콘텐츠를 다운로드, 캐시, 복제, 수정, 표시(본 단락에 명시된 경우 제외), 편집, 변경 또는 개선할 권리가 없음을 인정하고 동의합니다. Vercel은 제3자 콘텐츠와 관련하여 상품성, 특정 목적에의 적합성 및 비침해에 대한 묵시적 보증을 포함하되 이에 국한되지 않는 모든 명시적, 묵시적 및 법적 보증 및 조건을 부인합니다."
    }), "\n", _jsx(_components.h2, {
      id: "다른-vercel-사이트-및-제3자-사이트에-대한-링크",
      children: "다른 Vercel 사이트 및 제3자 사이트에 대한 링크"
    }), "\n", _jsx(_components.p, {
      children: "본 사이트는 Vercel 및 그 서비스에 관한 기타 정보를 찾을 수 있는 다른 Vercel 사이트에 연결될 수 있습니다.\n본 사이트는 또한 Vercel 사이트가 아닌 다른 사이트에 연결됩니다. Vercel은 편의를 위해서만 이러한 링크를 귀하에게 제공하며, Vercel은 해당 사이트에 표시된 콘텐츠 또는 링크를 포함하되 이에 국한되지 않는 연결된 사이트에 대해 책임을 지지 않습니다."
    }), "\n", _jsx(_components.h2, {
      id: "무단-활동",
      children: "무단 활동"
    }), "\n", _jsx(_components.p, {
      children: "본 사이트에 포함된 자료 또는 제3자 콘텐츠를 무단으로 사용하는 것은 특정 법률 및 규정을 위반할 수 있습니다. 귀하는 본 사이트의 사용이 적용 가능한 법률 또는 규정, 또는 제3자의 저작권, 상표권 또는 기타 권리를 위반한다는 제3자의 청구 또는 요구와 관련하여, 그로부터 발생하거나, 이를 회피할 목적으로 Vercel 또는 기타 피면책 당사자가 겪는 모든 비용, 손해, 책임 및 비용(변호사 비용 및 변호 비용 포함)으로부터 Vercel 및 그 임원, 이사, 직원, 계열사, 대리인, 라이선서 및 비즈니스 파트너를 면책하고 손해로부터 보호하는 데 동의합니다."
    }), "\n", _jsx(_components.h2, {
      id: "소유권",
      children: "소유권"
    }), "\n", _jsx(_components.p, {
      children: "Vercel 및 Turborepo는 Vercel의 상표입니다. 본 사이트의 기타 상표, 이름 및 로고는 각 소유자의 재산입니다."
    }), "\n", _jsx(_components.p, {
      children: "본 약관에 달리 명시되지 않는 한, 문서, 서비스, 사이트 디자인, 텍스트, 그래픽, 로고, 이미지 및 아이콘과 이들의 배열을 포함하여 본 사이트에 나타나는 모든 정보 및 화면은 Vercel Inc.의 단독 재산입니다. Copyright © 2021-2022 Vercel Inc. 본 약관에 명시적으로 부여되지 않은 모든 권리는 유보됩니다. 적용 가능한 법률에 의해 달리 요구되거나 제한되는 경우를 제외하고, 저작권 소유자 또는 라이선스의 명시적 서면 동의 없이 저작권으로 보호되는 자료의 복제, 배포, 수정, 재전송 또는 출판은 엄격히 금지됩니다."
    }), "\n", _jsx(_components.h2, {
      id: "보증-부인",
      children: "보증 부인"
    }), "\n", _jsx(_components.p, {
      children: "본 사이트의 사용은 귀하의 책임입니다. 자료 및 제3자 콘텐츠는 Vercel에 의해 전체적으로 또는 부분적으로 검증되거나 인증되지 않았으며, 부정확한 내용 또는 오타 또는 기타 오류를 포함할 수 있습니다. Vercel은 본 사이트에 포함된 자료 또는 제3자 콘텐츠의 정확성 또는 적시성을 보증하지 않습니다. Vercel은 Vercel 또는 당사의 라이선서가 제공하는지 여부와 관계없이 자료 및/또는 제3자 콘텐츠의 오류 또는 누락에 대해 책임을 지지 않습니다."
    }), "\n", _jsx(_components.p, {
      children: "VERCEL은 자체 및 그 라이선서를 위하여, 본 사이트, 자료 또는 제3자 콘텐츠와 관련하여, 본 사이트에 포함되거나 제시된 정보 또는 자료의 품질, 적합성, 진실성, 정확성 또는 완전성 및/또는 자료 및 제3자 콘텐츠를 포함하되 이에 국한되지 않는 본 사이트의 사용으로부터 얻은 결과와 관련하여 명시적, 묵시적 또는 법적 진술, 보증 또는 보장을 하지 않습니다. 적용 가능한 법률에 의해 허용되는 최대 범위까지, 본 사이트, 서비스, 자료, 제3자 콘텐츠 및 본 사이트에 포함되거나 제시된 정보 또는 자료는 상품성, 특정 목적에의 적합성 또는 제3자 권리의 비침해에 대한 묵시적 보증 없이 \"있는 그대로\", \"사용 가능한 그대로\" 및 \"현재 상태 그대로\"를 기준으로 귀하에게 제공됩니다. VERCEL은 귀하의 컴퓨터에 설치될 수 있는 바이러스, 스파이웨어 또는 멀웨어에 대한 보증을 제공하지 않습니다. VERCEL은 귀하를 전문가 또는 고객으로 수락하거나 거부할지 여부에 대한 단독 재량권을 가집니다."
    }), "\n", _jsx(_components.h2, {
      id: "책임의-제한",
      children: "책임의 제한"
    }), "\n", _jsx(_components.p, {
      children: "VERCEL은 본 사이트로 또는 본 사이트로부터 자료 또는 제3자 콘텐츠를 표시, 복사 또는 다운로드하여 발생하는 손해에 대해 귀하에게 책임을 지지 않습니다. VERCEL이 그러한 손해의 가능성을 알고 있는 경우에도, 어떠한 경우에도 VERCEL은 간접적, 특별한, 예시적, 징벌적, 특수한, 부수적 또는 결과적 손해(데이터, 수익, 이익, 사용 또는 기타 경제적 이익의 손실 포함)에 대해 귀하에게 책임을 지지 않으며, 총 손해가 100달러를 초과하는 경우에도 마찬가지입니다."
    }), "\n", _jsx(_components.h2, {
      id: "현지-법률-수출-통제",
      children: "현지 법률; 수출 통제"
    }), "\n", _jsx(_components.p, {
      children: "Vercel은 미국 본사에서 본 사이트를 통제하고 운영하며 자료 및/또는 제3자 콘텐츠는 다른 지역에서 사용하기에 적절하지 않거나 사용할 수 없을 수 있습니다. 미국 외부에서 본 사이트를 사용하는 경우, 귀하는 적용 가능한 현지 법률을 준수할 책임이 있습니다."
    }), "\n", _jsx(_components.h2, {
      id: "일반-조항",
      children: "일반 조항"
    }), "\n", _jsx(_components.p, {
      children: "귀하가 본 약관을 위반하는 경우, Vercel은 통지 없이 본 사이트에 대한 귀하의 액세스를 종료 및/또는 일시 중단할 수 있습니다. 소유권, 보증 부인, 귀하가 한 진술, 면책, 책임의 제한 및 일반 조항은 본 약관의 종료 후에도 존속합니다."
    }), "\n", _jsx(_components.p, {
      children: "Vercel은 사이트에 통지를 게시하여 30일 전에 통지함으로써 때때로 본 약관을 변경할 수 있습니다. 귀하는 언제든지 본 사이트에서 본 약관의 최신 버전을 검토할 수 있습니다. 개정된 약관은 Vercel이 그러한 변경 사항에 대한 통지를 게시하거나 귀하에게 보낸 후 30일 후에 발효되며, 그 날짜 이후에 사이트를 사용하는 경우 귀하의 사용은 개정된 약관의 수락으로 간주됩니다. 본 약관에 대한 변경 사항이 귀하에게 받아들일 수 없는 경우, 귀하의 유일한 구제책은 사이트 사용을 중단하는 것입니다. 본 약관의 조항이 시행 불가능하거나 무효인 것으로 판명되는 경우, 본 약관이 달리 완전한 효력을 유지하고 시행 가능하도록 해당 조항은 필요한 최소한으로 제한되거나 제거됩니다. 귀하는 Vercel의 사전 서면 동의 없이 양도, 이전 또는 재라이선스할 수 없지만, Vercel은 제한 없이 본 약관을 전체적으로 또는 부분적으로 양도하거나 이전할 수 있습니다. 전술한 내용에 위배되는 당사자의 본 약관의 양도 또는 이전 시도는 무효입니다. 본 약관은 당사자 간의 상호 이해에 대한 완전하고 배타적인 진술이며 본 약관의 주제와 관련된 모든 이전의 서면 및 구두 계약, 통신 및 기타 이해를 대체하고 취소하며, 본 약관에 달리 규정된 경우를 제외하고 모든 수정 사항은 양 당사자가 서명한 서면으로 이루어져야 합니다. Vercel이 본 약관의 권리 또는 조항을 행사하거나 시행하지 않는 것은 해당 권리의 포기가 아닙니다. 본 약관의 결과로 대리, 파트너십, 합작 투자 또는 고용이 생성되지 않으며 어느 당사자도 어떠한 면에서든 상대방을 구속할 권한이 없습니다. 본 약관에 따른 권리를 시행하기 위한 소송 또는 절차에서 승소한 당사자는 비용 및 변호사 비용을 회수할 자격이 있습니다. 위에 명시된 경우를 제외하고, 본 약관에 따른 모든 통지는 서면으로 이루어지며 직접 전달된 경우 수령 시, 이메일로 전송된 경우 전자적으로 확인된 때, 공인 익일 배송 서비스로 익일 배송을 위해 발송된 경우 발송 다음 날, 등기 우편으로 발송된 경우 수령 시 정식으로 제공된 것으로 간주됩니다."
    }), "\n", _jsx(_components.p, {
      children: "Vercel의 이행 지연 또는 실패는 그러한 지연 또는 이행 실패가 Vercel의 합리적인 통제를 벗어난 사건(신의 행위 또는 공공의 적, 테러 행위, 팬데믹, 전염병, 노동 파업, 시설의 수용 또는 몰수, 예상치 못한 정식으로 공포된 정부 명령의 준수, 전쟁 행위, 반란 또는 사보타주 또는 그로 인한 손해, 화재, 홍수, 폭발 또는 폭동을 포함하되 이에 국한되지 않음)으로 인한 것이고, 그러한 범위 내에서, 그리고 그러한 기간 동안, 본 약관의 불이행을 구성하거나 손해 배상 청구를 발생시키지 않습니다."
    }), "\n", _jsx(_components.h2, {
      id: "준거법-분쟁-중재",
      children: "준거법; 분쟁; 중재"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "법률."
      }), " 본 약관은 캘리포니아주 법률의 저촉 규정에 관계없이 캘리포니아주 법률의 적용을 받으며, 당사자들은 샌프란시스코 카운티의 주 및 연방 법원의 전속 관할권에 동의합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "구속력 있는 계약."
      }), " 귀하는 본 약관이 전자적이며 귀하와 Vercel이 물리적으로 서명하지 않았더라도 귀하와 Vercel 간의 계약이며, 사이트의 사용을 규정함을 인정합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "중재."
      }), " 본 조항의 특정 부분은 연방 중재법(\"FAA\")에 따른 \"중재에 대한 서면 합의\"로 간주됩니다. 귀하와 Vercel은 본 조항이 연방 중재법의 \"서면\" 요건을 충족함을 명시적으로 동의하고 의도합니다. 본 조항은 상호 합의에 의해서만 수정될 수 있습니다. 본 조항의 목적상, \"청구\"는 (i) 관련된 모든 콘텐츠, 자료 및 소프트웨어를 포함한 사이트 및/또는 (ii) 귀하의 사이트 사용으로부터 발생하거나 이와 관련된 모든 청구, 상해, 요구, 책임, 분쟁, 소송 원인(법적, 계약적, 과실 또는 기타 불법 행위 이론 포함), 절차, 의무, 부채, 유치권, 벌금, 요금, 위약금, 계약, 약속, 비용, 지출(소송 전, 재판 전, 재판 중, 항소 중 또는 기타 시점에 발생했는지 여부와 관계없이 변호사 비용 포함), 모든 종류의 손해(결과적, 보상적 또는 징벌적 손해 포함) 또는 손실(알려진, 알려지지 않은, 주장된, 주장되지 않은, 확정된, 조건부 또는 우발적인 것인지 여부)을 총칭하여 의미하며 이에 국한되지 않습니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "비공식 분쟁 해결."
      }), " 본 약관에 규정된 경우를 제외하고 사이트 또는 본 약관으로부터 발생하거나 이와 관련된 청구가 발생하는 경우, 귀하와 Vercel은 청구에 대한 합리적인 설명과 제안된 해결책을 제공하는 통지를 상대방에게 보내는 데 동의합니다. 귀하에 대한 Vercel의 통지는 귀하가 Vercel에 제공한 가장 최근의 연락처 정보를 기반으로 전송됩니다. 그러한 정보가 존재하지 않거나 그러한 정보가 최신이 아닌 경우, Vercel은 본 조항에 따른 의무가 없습니다. 상대방으로부터 통지를 받은 날로부터 60일 동안, 귀하와 Vercel은 청구를 해결하기 위해 대화에 참여하지만, 귀하와 Vercel 각각의 단독 재량에 따라 편안하지 않은 조건으로 청구를 해결하도록 요구하는 것은 없습니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "적용 법률."
      }), " 귀하와 Vercel이 통지를 받은 날로부터 60일 이내에 청구를 해결할 수 없는 경우, 귀하는 그러한 청구 및 본 약관의 해석, 적용 가능성, 시행 가능성 또는 형성과 관련하여 발생하거나 관련된 모든 기타 분쟁(본 약관의 전부 또는 일부가 무효이거나 취소 가능하다는 청구 또는 청구가 귀하의 사이트 사용과 관련된 중재의 대상인지 여부를 포함하되 이에 국한되지 않음)이 법원이 아닌 구속력 있는 중재로 해결될 것에 동의합니다. 주법이 아닌 FAA가 아래의 집단 소송 포기를 포함하여 그러한 분쟁의 중재 가능성을 규정합니다. 그러나 귀하와 Vercel은 캘리포니아주 법률 또는 미국 연방법이 법률 선택 원칙에 관계없이 계약, 법령, 관습법 또는 기타 법적 이론에서 발생하거나 명시된 본 약관 및 사이트와 관련하여 귀하와 Vercel 간에 발생하는 모든 청구 또는 분쟁에 적절하게 적용되고 규정됨에 동의합니다. 중재에는 판사나 배심원이 없으며, 중재 판정에 대한 법원 검토는 제한됩니다. 그러나 중재인은 법원이 하는 것처럼 본 약관의 조건을 따라야 합니다. 구속력 있는 중재 및 집단 소송 포기에 대한 조항을 포함한 본 조항은 귀하의 계정 또는 서비스의 종료 후에도 존속합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "중재 요청."
      }), " 중재 절차를 시작하려면 중재를 요청하고 귀하의 청구를 설명하는 서신을 340 S Lemon Ave #4133, Walnut CA, 91789의 Vercel에 보내야 합니다. 중재는 중재가 개시될 때 시행 중인 JAMS 간소화 중재 절차 규칙에 따라 JAMS에 의해 수행되며, 집단 소송을 규정하거나 허용하는 규칙 또는 절차는 제외됩니다. 모든 제출, 관리 및 중재인 수수료의 지불은 JAMS의 규칙에 따라 규정됩니다. 중재는 캘리포니아주 샌프란시스코 또는 상호 합의된 다른 장소(및 그러한 절차에 따라)에서 진행됩니다. 귀하는 다음과 같이 JAMS 절차, 규칙 및 수수료 정보를 얻을 수 있습니다: JAMS: 800.352.5267 및 ", _jsx(_components.a, {
        href: "https://www.jamsadr.com",
        children: "https://www.jamsadr.com"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "수수료."
      }), " 귀하와 Vercel은 적용 가능한 중재 규칙에 따라 관리 및 중재인의 수수료 및 기타 비용을 지불합니다. 그러나 적용 가능한 중재 규칙 또는 법률이 본 조항이 시행 가능하도록 Vercel이 그러한 수수료 및 비용의 더 큰 부분 또는 전부를 지불하도록 요구하는 경우, Vercel은 수수료 및 비용을 지불하고 중재를 진행하기로 선택할 권리가 있습니다. 중재 규칙은 Vercel이 변호사 비용을 회수하는 것을 허용할 수 있습니다. Vercel은 중재인이 청구가 경솔하다고 판단하지 않는 한 중재에서 변호사 비용 및 비용을 회수하려고 하지 않습니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "집단 소송 포기."
      }), " 귀하와 VERCEL은 각각 분쟁 해결 절차가 집단, 통합 또는 대표 소송이 아닌 개인 기반으로만 수행될 것에 동의합니다. 귀하와 Vercel은 각각 그러한 절차가 캘리포니아 민사소송법 제638조에 따른 사법 참조 방식으로만 진행되어야 함에 동의합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "예외."
      }), " 중재를 통해 모든 분쟁을 해결한다는 합의에도 불구하고, 귀하 또는 Vercel은 지적 재산권(특허, 저작권, 상표, 영업 비밀 및 도덕적 권리를 포함하되 개인정보 보호 권리는 포함하지 않음)의 침해 또는 기타 오용을 금지하기 위해 법원에 소송을 제기할 수 있습니다. 귀하 또는 Vercel은 또한 해당 법원의 관할권 범위 내의 청구에 대해 소액 청구 법원에서 구제를 요청할 수 있습니다. 위의 중재 조항이 귀하 또는 특정 청구에 적용되지 않는 것으로 판명되는 경우, 귀하의 중재 조항 옵트아웃 결정의 결과로든 중재인의 결정 또는 법원 명령의 결과로든, 귀하는 그러한 청구 또는 분쟁에 대한 재판지가 캘리포니아주 샌프란시스코 카운티에 위치한 주 또는 연방 법원에만 있다는 데 동의합니다. 귀하와 Vercel은 중재 조항이 적용되지 않는 것으로 판명되는 경우 본 약관의 해석, 적용 가능성, 시행 가능성 또는 형성 또는 귀하의 사이트 사용과 관련하여 발생하거나 관련된 모든 그러한 청구 또는 기타 분쟁을 소송하기 위해 캘리포니아주 샌프란시스코 카운티 내에 위치한 법원의 대인 관할권에 복종하는 데 동의합니다. 그러한 경우, Vercel이 본 약관에 따른 권리를 시행하기 위해 귀하를 상대로 한 소송에서 승소하는 경우, Vercel은 Vercel이 받을 자격이 있는 모든 기타 손해 배상 또는 판정 외에도 분쟁을 해결하거나 합의하는 데 발생한 비용, 지출 및 합리적인 변호사 비용(재판, 항소 중 또는 준비 중 또는 기타 시점에 발생했는지 여부)을 받을 자격이 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "제한."
      }), " 적용 가능한 법률에 의해 허용되는 최대 범위까지, 귀하 또는 VERCEL이 상대방에 대해 분쟁을 주장하고자 하는 경우, 귀하 또는 VERCEL은 분쟁이 발생한 후 1년 이내에(본 약관에 명시된 대로 서면 통지를 전달하여) 이를 시작해야 하며 그렇지 않으면 영구히 금지됩니다. \"시작\"은 해당되는 경우 다음을 의미합니다: (i) 본 약관에 명시된 대로 서면 통지를 전달, (ii) 본 약관에 명시된 대로 JAMS에 중재 신청, 또는 (iii) 주 또는 연방 법원에 소송 제기. 이 조항은 사이트와 관련된 손실(또는 잠재적 손실), Vercel의 지적 재산권 및/또는 Vercel의 사이트 제공과 관련하여 금지 명령 또는 기타 형평법상 구제를 구하기 위해 Vercel이 취한 법적 조치에는 적용되지 않습니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "옵트아웃."
      }), " 귀하는 ", _jsx(_components.a, {
        href: "mailto:privacy@vercel.com",
        children: "privacy@vercel.com"
      }), "으로 제목란에 \"COMPANY ARBITRATION AND CLASS ACTION WAIVER OPT-OUT\"을 기재하여 옵트아웃 결정에 대한 서면 통지를 보냄으로써 위에 명시된 중재 및 집단 소송 포기 조항에 구속되지 않도록 옵트아웃할 권리가 있습니다. 통지는 사이트의 첫 사용 후 30일 이내에 보내야 하며, 그렇지 않으면 귀하는 구속력 있는 중재를 규정하는 본 약관에 따라 분쟁을 중재하도록 구속됩니다. 귀하가 이러한 중재 조항을 옵트아웃하는 경우, Vercel도 이에 구속되지 않습니다."]
    }), "\n", _jsx(_components.p, {
      children: "최종 업데이트 날짜: 2021년 12월 8일"
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
